import { FC, useContext } from 'react'
import { InternalContext } from '../contexts/InternalContext'
import SvgVolumeHigh from '../../components/icons/VolumeHigh'
import SvgVolumeMedium from '../../components/icons/VolumeMedium'
import SvgVolumeLow from '../../components/icons/VolumeLow'
import SvgVolumeOff from '../../components/icons/VolumeOff'
import './ControlsVolumeIcon.scss'

export const ControlsVolumeIcon: FC = () => {
  const {
    audioPlayer: { mute, volume },
  } = useContext(InternalContext)

  return (
    <div className="ControlsVolumeIcon">
      {mute ? <SvgVolumeOff /> : volume === 0 ? <SvgVolumeLow /> : volume < 1 ? <SvgVolumeMedium /> : <SvgVolumeHigh />}
    </div>
  )
}
